import { defineStore } from 'pinia';

import companyRepository from '@/api/companyRepository';
import type { Company } from '@/types/company';

interface State {
  companies: Company[] | []
}

export const useCompanyStore = defineStore('companyStore', {
  state: (): State => {
    return {
      companies: []
    };
  },

  actions: {
    async getCompanies() {
      const { data } = await companyRepository.getCompanies();
      this.$state.companies = data;
    }
  }
});
